import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Loading1Component } from './loading1/loading1.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { Loading2Component } from './loading2/loading2.component';
import { Loading3Component } from './loading3/loading3.component';
import { Loading4Component } from './loading4/loading4.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatInputModule,
  MatRippleModule,
  MatFormFieldModule,
  MatTooltipModule,
  MatCardModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatDatepickerModule,
  MatRadioModule,
  MatCheckboxModule,
  MatStepperModule,
  MatExpansionModule,
  MatIconModule,
  MatAutocompleteModule,
  MatPaginatorModule,
  MatNativeDateModule,

} from '@angular/material';
import { Loading5Component } from './loading5/loading5.component';
import { MiniLoading1Component } from './mini-loading1/mini-loading1.component';
import { ProgressComponent } from './progress/progress.component';
import { ArchivoDirective } from './archivo.directive';
import { DashboardTablerosComponent } from 'app/dashboardTableros/dashboardTableros.component';

@NgModule({
  declarations: [
    Loading1Component,
    DashboardComponent,
    Loading2Component,
    Loading3Component,
    Loading4Component,
    Loading5Component,
    MiniLoading1Component,
    ProgressComponent,
    ArchivoDirective,
    DashboardTablerosComponent
  ],
  imports: [
    MatButtonModule,
    MatInputModule,
    MatRippleModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatCheckboxModule,
    MatPaginatorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatStepperModule,
    MatExpansionModule,
    MatIconModule,
    MatAutocompleteModule,
    MatInputModule,
  ],
  exports: [
    MatButtonModule,
    MatInputModule,
    MatRippleModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatCheckboxModule,
    MatPaginatorModule,
    Loading1Component,
    Loading2Component,
    Loading3Component,
    Loading4Component,
    Loading5Component,
    ProgressComponent,
    ArchivoDirective,
    MiniLoading1Component,
    ReactiveFormsModule,
    FormsModule,
    DashboardComponent,
    DashboardTablerosComponent
  ]

})
export class SharedModule { }
